<template>
  <div class="fsb-section" :class="{ 'fsb-section-last': last }">
    <button class="fsb-section-header" type="button" @click="open = !open">
      <span class="fsb-section-title">{{ title }}</span>
      <svg
        class="fsb-chevron"
        :class="{ open: open }"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
    <div v-show="open" class="fsb-section-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// Collapsible section (.fsb-section/.fsb-section-header/.fsb-chevron/.fsb-section-body, styled
// globally in main.scss) with generic content via the default slot.
export default {
  name: 'filterAccordionSection',
  props: {
    title: { type: String, required: true },
    last: { type: Boolean, default: false },
    startOpen: { type: Boolean, default: false },
  },
  data() {
    return {
      open: this.startOpen,
    }
  },
}
</script>

<style scoped>
/* .fsb-section-body's global gap (8px) is meant for grouped rows (several filters inside one
   .fsb-field, 4px apart). The catalog has no such row grouping, so every filter here gets its own
   top-level .fsb-field directly under .fsb-section-body — inheriting the wider 8px everywhere ends
   up looking like extra space between a field and the one above it. Use the tighter 4px value instead. */
.fsb-section-body {
  gap: 4px;
}

/* .fsb-section/.fsb-section-last (the divider between accordion sections) are not in
   main.scss alongside .fsb-section-header/-title/-body/.fsb-chevron, so they are defined here, scoped. */
.fsb-section {
  border-bottom: 1px solid #f3f4f6;
}
.fsb-section-last {
  border-bottom: none;
}
</style>
